import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type RadioStory from "./RadioStory";

@Model()
class RadioStoryFragment extends ApplicationRecord {
  static jsonapiType = "radio_story_fragments";

  @Attr({ persist: false }) channelId: number;

  @Attr({ persist: false }) endTime: number;

  @BelongsTo() radioStory: RadioStory;

  @Attr({ persist: false }) radioStoryId: number;

  @Attr() speaker: string;

  @Attr({ persist: false }) startTime: number;

  @Attr() text: string;
}

export default RadioStoryFragment;
